module.exports = __webpack_public_path__ + "img/JuergenStelck_140x140_rund.9a42e728.jpg";